// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useCallback } from "react";
import { Modal } from "antd";
import { loadStripe } from "@stripe/stripe-js/pure";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import cx from "classnames";

// -----------------------------------------------------------------------------
// Components and Helpers
// -----------------------------------------------------------------------------
import { Heading2 } from "themes/default/_typography";
import { notification } from "antd";
import { useStripeCreateMemberCheckoutSessionMutation } from "store/api/api";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

// -----------------------------------------------------------------------------
// Modal Component
// -----------------------------------------------------------------------------
const MemberSubscriptionModal = ({ open, onClose, gymId, customerId, gymName, afterSubscribe }) => {
	const [createSession] = useStripeCreateMemberCheckoutSessionMutation();

	const fetchClientSecret = useCallback(async () => {
		try {
			const { data } = await createSession({ gym_id: gymId, customer_id: customerId });
			return data.client_secret;
		} catch (err) {
			notification.error({ message: "Failed to create checkout session." });
		}
	}, [gymId, customerId]);

	return (
		<Modal
			className={cx("sb-member-subscription-modal")}
			title={<Heading2>Subscribe to {gymName}</Heading2>}
			centered
			open={open}
			onCancel={onClose}
			width={656}
			footer={null}
			maskClosable={false}
			closable
		>
			<div id="checkout">
				<EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret, onComplete: afterSubscribe }}>
					<EmbeddedCheckout />
				</EmbeddedCheckoutProvider>
			</div>
		</Modal>
	);
};

export default MemberSubscriptionModal;

